'use client';

import posthog from 'posthog-js';
import { PostHogProvider as PHProvider } from 'posthog-js/react';
import { useEffect } from 'react';

export function PostHogProvider({ children }: { children: React.ReactNode }) {
  useEffect(() => {
    // 🛡️ Safe check: do not track in development
    if (import.meta.env.DEV) return;

    const isLocal = window.location.host.includes('localhost');
    const posthogKey =
      import.meta.env.VITE_POSTHOG_KEY || 'phc_4HsvHcaMh8RssHsF7zYk0cLZGspZWg0bBMUenjoqa1s';
    const posthogHost = import.meta.env.VITE_POSTHOG_HOST || 'https://us.i.posthog.com';

    posthog.init(posthogKey, {
      api_host: posthogHost,
      person_profiles: 'identified_only',
      // We capture manually via PostHogPageView to ensure accuracy in SPA
      capture_pageview: false, 
      capture_pageleave: true,
      persistence: 'localStorage+cookie',
      cross_subdomain_cookie: !isLocal,
    });

    // Optional: Tag all events from this app instance
    posthog.register({
      host: 'app.tufirma.pro',
      site_section: 'dashboard',
    });
  }, []);

  return <PHProvider client={posthog}>{children}</PHProvider>;
}
